<template>
  <div class="loginPage" ref="loginDiv">
    <!-- 顶部空白部分 -->
    <div
            style="width:100%;min-height:80px;background: transparent;width: 1000px;position: relative;margin: 0px auto;"
            :style="{height: topBlankHeight}"
    ></div>

    <div class="mainBox">
      <!--  登录框-输入账号密码  -->
      <!-- v-if="!showCheckBox" -->
      <div
              class="loginBox inputLoginBox"
              :class="{
                    'loginBoxIn': showWhiteBoxIn,
                    'show': !showCheckBox
                }"
      >
        <div class="topIcon" :class="{'topIconIn': showDingZiIn}"></div>
        <div class="titleLogo"></div>
        <div class="inputBox">
          <i class="left user"></i>
          <input v-model="account" type="text" placeholder="请输入账号" id="LOGIN_USER_NAME_INPUT"></div>
        <div class="inputBox">
          <i class="left password"></i>
          <input v-model="password" type="password" placeholder="请输入密码" @keyup.enter="loginEvent"
                 id="LOGIN_PASSWORD_INPUT"></div>
        <button @click="loginEvent" class="loginBtn" type="button">登录</button>
      </div>


      <!--  登录框-滑动验证  -->
      <!-- 用v-if控制时，滑块无法滑动，所以用display:none;控制 -->
      <!-- v-if="showCheckBox" -->
      <div
              class="loginBox checkBox"
              :class="{
                    'loginBoxIn': showWhiteBoxIn, 
                    'show': showCheckBox
                }"
      >
        <div class="topIcon" :class="{'topIconIn': showDingZiIn}"></div>
        <div class="titleLogo"></div>

        <div class="captchaBox">
          <div class="line"></div>

          <div class="captchaHeader">
            <div @click="showCheckBox = false" class="left">
              <img src="@/assets/images/login/arrowIcon.png"/>
              <span>返回</span>
            </div>
            <h3>安全验证</h3>
          </div>

          <div class="tipText">
            <span>请控制拼图块对齐缺口</span>
            <div @click="refreshEvent" title="刷新" class="reset">
              <img src="@/assets/images/login/resetIcon.png"/>
              <span>刷新</span>
            </div>
          </div>

          <div class="image-box">
            <!--底图-->
            <div id="sourceImagesBlock" class="source-images-block"></div>
            <!--大凹图-->
            <div id="bigCutImagesBlock" class="big-cut-images-block"></div>
            <!--小凹图-->
            <div id="smallCutImagesBlock" class="small-cut-images-block"></div>
            <!--loading-->
            <div id="loadingDiv" class="loading-div">Loading...</div>
          </div>

          <div id="dragBox" class="drag-box">
            <div class="drag-box-progress"></div>
            <div id="dragger" class="drag-box-block"></div>
          </div>

        </div>

      </div>
    </div>

    <!--  菜单  -->
    <ul class="navBox" id="navBoxDiv">
      <li onclick="window.open('http://demo.esaleb.com/!ESale/Mall/UI/~view/wxPay','_blank')">
        <i class="iconCode"></i>
        <div class="liTitle">扫码支付</div>
      </li>
      <li onclick="window.open('tencent://message/?uin=800005438&site==QQ%E4%BA%A4%E8%B0%88&Menu=yes','_blank')">
        <i class="iconService"></i>
        <div class="liTitle">客服服务</div>
      </li>
      <li onclick="window.open('http://demo.esaleb.com/!ESale/Mall/UI/~view/consumerservice','_blank')">
        <i class="iconQuestion"></i>
        <div class="liTitle">常见问题</div>
      </li>
      <li onclick="window.open('http://demo.esaleb.com/!ESale/Mall/UI/~view/download','_blank')">
        <i class="iconDownload"></i>
        <div class="liTitle">相关下载</div>
      </li>
    </ul>

    <!-- 底部备案号 -->
    <div class="footer_bei">
      <a href="http://beian.miit.gov.cn" target="_blank" style="color:#ffffff;"> 粤ICP备14049903号 </a> 
      Copyright©2018 版权所有 广州市森锐科技股份有限公司
    </div>
  </div>
</template>

<script>
  import $ from 'jquery';
  import md5 from 'js-md5';
  import {
    getCaptchaImageReqAPI, // 获取验证图片以及位置
    login, // 查询验证图片是否通过
    oldLogin
  } from "@/api/login.js";
  import {setTimeout} from 'timers';
  import {CAPTCHA_TOKEN} from '@/service/keys.js';
  import {objectToQueryString} from '@/utils/commonUtils.js';

  export default {
    name: "login",
    data() {
      return {
        showWhiteBoxIn: false, // 默认不显示白色内容进入页面
        showDingZiIn: false, // 默认不显示钉子进入页面
        topBlankHeight: '', // 页面顶部空白的高度

        showCheckBox: false, // false-显示输入框，true-显示验证图片
        // showCheckBox: true, // false-显示输入框，true-显示验证图片

        account: '', // 账号
        password: '', // 密码
        captchaX: '', // 滑动值
        captchaVisible: false,
        isSlider: false, // 滑块是否能滑动
        timer: null
      }
    },
    mounted() {
      this.$nextTick(() => {
        // 显示白色内容进入页面
        //显示钉子进入页面
        setTimeout(() => {
          this.showWhiteBoxIn = true;
          this.showDingZiIn = true;
        }, 200);

        // 初始化验证图
        this.initCaptchaImage();
        // 初始监听拖动事件
        this.dragEvent();
      })
    },
    created() {
      // 获取白色盒子距离顶部的高度
      this.initGetHeight();
    },
    methods: {
      // 第一次进入页面时，获取白色盒子距离顶部的高度(通过当前template的高度计算)
      initGetHeight() {
        let _this = this
        this.$nextTick(() => {
          let fullHeight = _this.$refs.loginDiv.clientHeight;
          let topHeight = 0.1161 * fullHeight;
          _this.topBlankHeight = topHeight + 'px';
        })
      },
      // 登录
      loginEvent() {
        if (!this.account) {
          this.$message({
            message: '请输入账号',
            type: 'warning'
          })
          return
        }
        if (!this.password) {
          this.$message({
            message: '请输入密码',
            type: 'warning'
          })
          return
        }

        // 显示验证框
        this.showCheckBox = true;
      },
      // 初始化验证图
      initCaptchaImage() {
        this.captchaX = 0;
        $('#loadingDiv').show();

        // 获取图片以及位置
        getCaptchaImageReqAPI().then((res) => {
          let result = res.data;
          this.$localStorage.set(CAPTCHA_TOKEN, result.token)
          // 图片
          $('#sourceImagesBlock').css('background-image', `url(data:image/png;base64,${result.sourceImg})`);

          $('#bigCutImagesBlock').css('background-image', `url(data:image/png;base64,${result.bigImg})`);
          // 大图使用流的形式获取，因为base64在IE8超过32K就不能正常解析了
          // $('#bigCutImagesBlock').css('background-image', `url("${this.$baseUrl}!ESale/Mall/UI/~java/SlideCaptcha.getBigImage?d=${Math.random()}")`);

          $('#smallCutImagesBlock').css('background-image', `url(data:image/png;base64,${result.smallImg})`);

          $('#smallCutImagesBlock').css('top', parseInt(result.locationY));

          // 位置
          $('#dragger').css('transition', 'left 0.5s ease 0s');
          $('#dragger').css('left', 0);
          $('#smallCutImagesBlock').css('left', 0);
          // 获取到了数据,确定了可以滑动
          this.isSlider = true;
          // console.log('确定了可以滑动', '')
          // 隐藏loading
          $('#loadingDiv').hide();
        })
      },
      // 刷新
      refreshEvent() {
        this.initCaptchaImage();
      },
      // 滑动事件
      dragEvent() {
        let _this = this;
        let dragBox = $('#dragBox'); // 容器
        let dragger = $('#dragger'); // 滑块
        let isMove = false; // 是否开始移动
        let startMoveX = 0; // 开始移动点的横坐标
        let maxWidth = dragBox.width() - dragger.width();
        // 滑块
        dragger.mousedown(function (e) {
          // console.log("开始按下");
          if (!_this.isSlider) return;
          dragger.css('transition', 'inherit');
          startMoveX = e.pageX - parseInt(dragger.css('left'));
          isMove = true;
        })
        // 容器
        dragBox.mousemove(function (e) {
          if (isMove) { // 只有按下才算开始移动
            let _x = e.pageX - startMoveX; // 在容器中鼠标移动了多少距离
            if (_x > 0 && _x <= maxWidth) {
              $('#smallCutImagesBlock').css({'left': _x});
              dragger.css({'left': _x})
            } else {  // 滑动超出容器
              // isMove = false
            }
          }
        })
            .mouseup(function (e) {
              isMove = false;
              _this.captchaX = e.pageX - startMoveX;
              if (_this.isSlider && _this.captchaX > 10) {
                _this.verifyEvent();
              }
            })
        // 在外面松开的时候再进入不能移动
        $('body').mouseup(function (e) {
          isMove = false;
        })
      },

      // 验证滑动
      async verifyEvent() {
        console.log(md5(this.password));
        const loginInfo = {
          account : this.account,
          password: md5(this.password),
          c: this.captchaX,
          c_t: this.$localStorage.get(CAPTCHA_TOKEN),
          platform: 'pc'
        }

        // 旧系统登录参数
        let param = {
          version: '1.0',
          account: this.account,
          password: this.password
        };

        try {

          // 非开发环境才进行旧系统登录
          if (!this.$variable.isDev()) {
            await oldLogin(param)
          }
          await this.$store.dispatch('user/userLogin', objectToQueryString(loginInfo))
          // 如果验证成功,跳转页面
          console.log('thishhhhh',this)
          this.$router.push('/accountManage/accountManageIndex');

          setTimeout(() => {
            this.$message('登录成功，欢迎进入易售宝平台管理系统');
          }, 2000);
        } catch (err) {
          console.log(err.response)
          if (err.response.status == 400) {
            this.initCaptchaImage()
          } else if (err.response.status != 200) {
            this.showCheckBox = false;
            this.initCaptchaImage()
          }
        }
      },

    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .loginPage {
    width: 100%;
    height: 100vh;
    margin: 0px auto;
    background: #444444;
    position: relative;
    overflow: hidden;
  }

  .loginPage .mainBox {
    width: 828px;
    min-width: 828px;
    height: 401px;
    min-height: 401px;
    position: relative;
    margin: 0px auto;
    background: url("../../assets/images/login/loginBg.png") no-repeat;
    background-size: 100% 100%;
    z-index: 1;
  }

  /* 登录框 */
  .loginPage .mainBox .loginBox {
    width: 288px;
    height: 332px;
    position: relative;
    margin: 0px auto;
    background: #ffffff;
    box-sizing: border-box;
    padding: 33px 0 0;

    box-shadow: 5px 70px 20px #222222;
    -moz-box-shadow: 5px 70px 20px #222222;
    -webkit-box-shadow: 5px 70px 20px #222222;

    transform: translateX(280%);
    // transform: translateX(60vw);
    -webkit-transition: all .5s ease-out;
    -moz-transition: all .5s ease-out;
    -ms-transition: all .5s ease-out;
    transition: all .5s ease-out;

  }

  .loginPage .mainBox .loginBoxIn {
    transform: translateX(0);
  }

  .loginPage .mainBox .loginBox.inputLoginBox {
    display: none;
  }

  .loginPage .mainBox .loginBox.inputLoginBox.show {
    display: block;
  }

  .loginPage .mainBox .loginBox.checkBox {
    display: none;
  }

  .loginPage .mainBox .loginBox.checkBox.show {
    display: block;
  }


  /* 钉子 */
  .loginPage .mainBox .loginBox .topIcon {
    /* margin: 0 0 0 39px; */
    width: 40px;
    height: 40px;
    background: url("../../assets/images/login/nail.png") no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: -16px;
    left: calc(50% - 20px);

    transform: translate3d(50vw, -10vh, -20px);
    -webkit-transition: all 1s ease-out;
    -moz-transition: all 1s ease-out;
    -ms-transition: all 1s ease-out;
    transition: all 1s ease-out;
  }

  .loginPage .mainBox .loginBox .topIconIn {
    /* transform: translateX(0); */
    transform: translate3d(0, 0, 0);
  }


  .loginPage .mainBox .loginBox .titleLogo {
    margin: 0 0 0 39px;
    width: 211px;
    height: 32px;
    background: url("../../assets/images/login/logo.png") no-repeat;
    background-size: 100% 100%;
  }

  .loginPage .mainBox .loginBox .inputBox {
    clear: both;
    margin: 26px 0 0 24px;
    width: 240px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #EEEEEE;
    box-sizing: border-box;
  }

  .loginPage .mainBox .loginBox .inputBox + .inputBox {
    margin-top: 10px;
  }

  .loginPage .mainBox .loginBox .inputBox .left {
    display: block;
    float: left;
    width: 24px;
    height: 24px;
    margin-left: 6px;
    margin-top: 8px;
  }

  .loginPage .mainBox .loginBox .inputBox .left.user {
    background: url("../../assets/images/login/userIcon.png") no-repeat;
    background-position: center;
  }

  .loginPage .mainBox .loginBox .inputBox .left.password {
    background: url("../../assets/images/login/lockIcon.png") no-repeat;
    background-position: center;
  }

  .loginPage .mainBox .loginBox .inputBox input {
    border: none;
    outline: none;
    font-size: 13px;

    width: calc(100% - 24px - 6px);
    /* height: 100%; */
  }

  .loginPage .mainBox .loginBox .inputBox ::-webkit-input-placeholder {
    color: #D1D1D1;
  }

  .loginPage .mainBox .loginBox .loginBtn {
    cursor: pointer;
    width: 240px;
    height: 44px;
    line-height: 44px;
    margin-top: 32px;
    margin-left: 24px;
    border-radius: 141px;
    background: #FA6241;
    box-shadow: 0px 3px 12px #FFC7BB;
    border: none;
    color: #fff;
    font-size: 15px;
    border: none;
    outline: none;
  }

  .loginPage .mainBox .loginBox .loginBtn:active {
    background: #FA6241;
  }

  /* 滑动验证-start */


  .checkBox .captchaBox {
    width: 100%;
    padding: 0 24px;
    margin-top: 26px;
    box-sizing: border-box;
  }

  .checkBox .line {
    width: 100%;
    height: 1px;
    background: #EEEEEE;
    margin: 0px 0px 8px 0px;
  }

  .checkBox .captchaHeader {
    width: 100%;
    line-height: 19px;
  }

  .checkBox .captchaHeader .left {
    cursor: pointer;
    /* position: relative; */
    height: 19px;
    font-size: 14px;
    color: #34333A;
    white-space: nowrap;
    display: inline-block;
  }

  .checkBox .captchaHeader .left img {
    width: 16px;
    height: 16px;
    margin-top: 1px;
    float: left;
    display: block;
  }

  .checkBox .captchaHeader h3 {
    font-size: 14px;
    font-weight: bold;
    color: #34333A;
    margin-left: 46px;
    display: inline-block;
  }

  .checkBox .tipText {
    color: #FA6241;
    font-size: 12px;
    margin-top: 10px;
    margin-bottom: 8px;
    height: 16px;
    line-height: 16px;
  }

  .checkBox .tipText .reset {
    height: 16px;
    cursor: pointer;
    display: inline-block;
    float: right;
  }

  .checkBox .tipText .reset img {
    width: 12px;
    height: 12px;
    margin-right: 4px;
    margin-top: 2px;
    display: block;
    float: left;
  }

  .checkBox .image-box {
    width: 240px;
    height: 128px;
    position: relative;
    margin-bottom: 14px;
    box-sizing: border-box;
  }

  .checkBox .image-box .source-images-block {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    /* background-size: cover; */
    background-repeat: no-repeat;
  }

  .checkBox .image-box .big-cut-images-block {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
    width: 100%;
    height: 100%;
    /* background-size: cover; */
    background-repeat: no-repeat;
  }

  .checkBox .image-box .small-cut-images-block {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 4;
    width: 50px;
    height: 50px;
    /* background-size: cover; */
    background-repeat: no-repeat;
    /* background-color: rgb(190, 79, 54) */
  }

  .checkBox .image-box .loading-div {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 5;
    font-size: 17px;
    color: #d1d1d1;
    background-color: #585858; /* IE6和部分IE7内核的浏览器(如QQ浏览器)下颜色被覆盖 */
    background-color: rgba(88, 88, 88, 0.6); /* IE6和部分IE7内核的浏览器(如QQ浏览器)会读懂，但解析为透明 */
    filter: alpha(opacity=60);
    text-align: center;
    box-sizing: border-box;
    padding-top: 52px;
  }

  .checkBox .drag-box {
    width: 240px;
    height: 24px;
    position: relative;
    padding-top: 9px;
    box-sizing: border-box;
  }

  .checkBox .drag-box-progress {
    width: 240px;
    height: 6px;
    border-radius: 123px;
    background: #E4E4E4;
    /* background: rgba(228,228,228,1); */
  }

  .checkBox .drag-box-block {
    width: 50px;
    height: 24px;
    position: absolute;
    top: 0;
    left: 0;
    cursor: move;
    background-image: url("../../assets/images/login/dragBlockIcon.png");
    background-size: cover;
    user-select: none;
  }

  /* 清除浮动 */
  .clearfix:after {
    content: '';
    display: block;
    clear: both;
  }


  /* 滑动验证-end */


  /* 登录框底部拼接图片 */
  .loginPage .mainBox .loginBox::after {
    content: '';
    width: 100%;
    width: 288px;
    height: 43px;
    position: absolute;
    bottom: -43px;
    left: 0;
    background: url("../../assets/images/login/loginBoxBottom.png") no-repeat;
    background-size: 100% 100%;
  }


  /* 菜单 */
  .loginPage .navBox {
    width: 412px;
    height: 58px;
    position: relative;
    margin: 0px auto;
    margin-top: 111px;
    z-index: 22;
    padding-bottom: 331px;
  }

  .loginPage .navBox li {
    width: 52px;
    height: 58px;
    float: left;
  }

  .loginPage .navBox li + li {
    margin-left: 68px;
  }

  .loginPage .navBox li:hover {
    cursor: pointer;
  }

  .loginPage .navBox li i {
    display: block;
    width: 32px;
    height: 32px;
    position: relative;
    margin: 0px auto;
  }

  .loginPage .navBox li i.iconCode {
    background: url("../../assets/images/login/qrcodeIcon.png") no-repeat;
    background-size: 100% 100%;
  }

  .loginPage .navBox li i.iconService {
    background: url("../../assets/images/login/serviceIcon.png") no-repeat;
    background-size: 100% 100%;
  }

  .loginPage .navBox li i.iconQuestion {
    background: url("../../assets/images/login/questionIcon.png") no-repeat;
    background-size: 100% 100%;
  }

  .loginPage .navBox li i.iconDownload {
    background: url("../../assets/images/login/downloadIcon.png") no-repeat;
    background-size: 100% 100%;
  }

  .loginPage .navBox li:hover i.iconCode {
    background: url("../../assets/images/login/qrcodeIcon_on.png") no-repeat;
    background-size: 100% 100%;
  }

  .loginPage .navBox li:hover i.iconService {
    background: url("../../assets/images/login/serviceIcon_on.png") no-repeat;
    background-size: 100% 100%;
  }

  .loginPage .navBox li:hover i.iconQuestion {
    background: url("../../assets/images/login/questionIcon_on.png") no-repeat;
    background-size: 100% 100%;
  }

  .loginPage .navBox li:hover i.iconDownload {
    background: url("../../assets/images/login/downloadIcon_on.png") no-repeat;
    background-size: 100% 100%;
  }

  .loginPage .navBox li .liTitle {
    width: 52px;
    height: 17px;
    line-height: 17px;
    margin-top: 9px;
    font-size: 13px;
    color: #111111;
  }

  .loginPage .navBox li:hover .liTitle {
    color: #FA6241;
  }
  .footer_bei{
    font-size: 12px;
    color: #fff;
    text-align: center;
    position: absolute;
    bottom: 0;
    width: 100%;
    line-height: 35px;
    z-index: 100;
  }
</style>
